const colors = {
    primary: "black",
    secundary: "#30333B",
    terteary: "#1AD987",
    quaternary: "#F5F4F3",
    white: "#fff",
    black: "#000000",
};

export default colors